import Raven from 'raven-js';
import { Metrics } from '../../utils/metrics';
export const logApiSuccess = context => {
  Metrics.counter('v2-api-request-success', {
    query: context.queryName,
    operation: context.operation,
    version: context.version
  }).increment();
};
export const logApiError = (error, context) => {
  var _error$graphQLErrors$, _error$graphQLErrors;
  const errorCode = (_error$graphQLErrors$ = error === null || error === void 0 || (_error$graphQLErrors = error.graphQLErrors) === null || _error$graphQLErrors === void 0 || (_error$graphQLErrors = _error$graphQLErrors[0]) === null || _error$graphQLErrors === void 0 || (_error$graphQLErrors = _error$graphQLErrors.extensions) === null || _error$graphQLErrors === void 0 || (_error$graphQLErrors = _error$graphQLErrors.code) === null || _error$graphQLErrors === void 0 ? void 0 : _error$graphQLErrors.toString()) !== null && _error$graphQLErrors$ !== void 0 ? _error$graphQLErrors$ : 'unknown';
  Metrics.counter('v2-api-request-error', {
    query: context.queryName,
    operation: context.operation,
    error_type: errorCode,
    version: context.version
  }).increment();
  Raven.captureException(new Error(errorCode), {
    extra: {
      query: context.queryName,
      operation: context.operation,
      errorCode,
      version: context.version,
      variables: context.variables
    },
    tags: {
      api_version: context.version,
      query_name: context.queryName,
      error_code: errorCode
    }
  });
};